import type { CSSProperties, ReactNode } from "react";
import "./fx.css";

/**
 * ReactBits glare-hover 포팅 (home-ui-spec §2.3·§8). CSS transition만 사용 —
 * hover 진입 시 사선 광택 1스윕, reduced-motion 시 미적용(fx.css).
 */
export interface GlareHoverProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  /** 글레어 색 (§2.3: rgba(255,255,255,0.18)) */
  glareColor?: string;
  /** 사선 각도 deg (§2.3: 45) */
  glareAngle?: number;
  /** 스윕 시간 ms (§2.3: 650) */
  glareDuration?: number;
}

export function GlareHover({
  children,
  className,
  style,
  glareColor = "rgba(255, 255, 255, 0.18)",
  glareAngle = 45,
  glareDuration = 650,
}: GlareHoverProps) {
  return (
    <div className={`ty-fx-glare-host ${className ?? ""}`} style={style}>
      {children}
      <span
        aria-hidden
        className="ty-fx-glare"
        style={
          {
            "--fx-glare-color": glareColor,
            "--fx-glare-angle": `${glareAngle}deg`,
            "--fx-glare-duration": `${glareDuration}ms`,
          } as CSSProperties
        }
      />
    </div>
  );
}
